<div id="mobile-overlay" [ngClass]="{ active: active }">
  <div id="side-menu" [ngClass]="{ 'unit-menu': isUnitMenu() }">
    <div *ngIf="active" class="row mt-4 mb-4 ml-3 mr-4">
      <div class="ml-10 d-flex justify-content-between">
        <button *ngIf="selectedSection" (click)="back()" class="back-button">
          <uni-icon name="arrow-left"></uni-icon> Volver
        </button>

        <button class="btn btn-icon float-right close-button overlay-close-button" (click)="hide()">
          <i-feather name="x"></i-feather>
        </button>
      </div>

      <div *ngIf="!selectedSection; else sectionTitle" class="col-12 mt-5 mb-4">
        <div class="row">
          <div class="col-3 col-sm-2">
            <button type="button" class="mobile-user-logo small-shadow-box"></button>
          </div>
          <div class="col-9 col-sm-10 pl-3 menu-heading">
            <h2 uni-heading weight="normal" color="inverse">
              {{ currentUser?.nombreCompleto | titlecase }}
            </h2>
            <div>{{ currentUser?.metadata?.email }}</div>
            <div>
              <button type="button" class="btn btn-default text-info password-manuals-font p-0" (click)="resetPassword()">
                Cambiar Contraseña
              </button>
            </div>
          </div>
        </div>
      </div>

      <ng-template #sectionTitle>
        <div class="col-12 mt-4 mb-1">
          <h2 uni-heading color="inverse">{{ selectedSection?.name }}</h2>
        </div>
      </ng-template>

      <div class="col-md-12 mt-1">
        <ul *ngIf="!selectedSection" class="sections-list">
          <li *ngFor="let section of menu">
            <button *ngIf="section.childs; else link" (click)="selectSection(section)">
              <ng-container
                [ngTemplateOutlet]="menuItem"
                [ngTemplateOutletContext]="{ section: section, showArrow: section.childs }"
              >
              </ng-container>
            </button>

            <ng-template #link>
              <a class="link" [routerLink]="section.childs ? section.childs[0].url : section.url">
                <ng-container [ngTemplateOutlet]="menuItem" [ngTemplateOutletContext]="{ section: section }"> </ng-container>
              </a>
            </ng-template>
          </li>
          <li>
            <button (click)="onClickSignOut()">
              <ng-container
                [ngTemplateOutlet]="menuItem"
                [ngTemplateOutletContext]="{ section: { name: 'Salir', icon: 'log-out', uni: true } }"
              >
              </ng-container>
            </button>
          </li>
        </ul>
      </div>

      <div *ngIf="selectedSection" class="col-md-12 mt-1">
        <ul class="sections-list">
          <li *ngFor="let section of selectedSection.childs">
            <button *ngIf="section.childs?.length > 1; else link" (click)="selectSection(section)">
              <ng-container [ngTemplateOutlet]="menuItem" [ngTemplateOutletContext]="{ section: section, showArrow: true }">
              </ng-container>
            </button>

            <ng-template #link>
              <a class="link" [routerLink]="section.childs ? section.childs[0].url : section.url">
                <ng-container [ngTemplateOutlet]="menuItem" [ngTemplateOutletContext]="{ section: section }"> </ng-container>
              </a>
            </ng-template>
          </li>
        </ul>
      </div>

      <div *ngIf="isUnitInstructivo()" class="col-md-12 mt-5 instructive-div">
        <a class="btn btn-default text-info password-manuals-font p-0" [routerLink]="['/portales/manuales']"
          >Instructivos de Uso</a
        >
      </div>
    </div>
  </div>
  <div id="overlay" (click)="hide()"></div>
</div>

<ng-template #menuItem let-section="section" let-showArrow="showArrow">
  <div class="section-name" [ngClass]="{ 'd-flex': section.icon }">
    <span class="section-icon" *ngIf="section.icon">
      <svg-icon *ngIf="!section.uni" [name]="section.icon"></svg-icon>
      <uni-icon *ngIf="section.uni" color="white" [name]="section.icon"></uni-icon>
    </span>
    <span class="white-circle" *ngIf="!section.icon"></span>
    <span>{{ section.name }}</span>
  </div>
  <uni-icon *ngIf="showArrow" color="white" size="sm" name="chevron-right"></uni-icon>
</ng-template>
